import { render, staticRenderFns } from "./UILanguagesList.vue?vue&type=template&id=63a05b29&scoped=true&"
import script from "./UILanguagesList.vue?vue&type=script&lang=js&"
export * from "./UILanguagesList.vue?vue&type=script&lang=js&"
import style0 from "./UILanguagesList.vue?vue&type=style&index=0&id=63a05b29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a05b29",
  null
  
)

export default component.exports